import { useMemo } from "react";
import { useRecordObjects } from "@/profitability/records/objects-context";
import type {
  ReportBlock,
  ReportDataQuery,
  ReportDataset,
} from "@/profitability/types";
import { filterRows, isBlank } from "./utils";

/**
 * A table block's rows, filtered here since they came with the report, and
 * only the flagged ones when the table asks for them. A table of a dataset
 * that names records is drawn as a record table.
 */
export const useTableRows = (
  block: ReportBlock,
  dataset: ReportDataset,
  filters: ReportDataQuery["filters"],
) => {
  const objects = useRecordObjects();
  const table = block.type === "table";
  const flagKey = dataset.columns.find((column) => column.flag)?.key;
  const flaggedOnly = block.type === "table" && !!block.flagged && !!flagKey;
  const tableRows = useMemo(() => {
    if (!table) return [];
    const rows = filterRows(dataset.rows, filters);
    return flaggedOnly && flagKey
      ? rows.filter((row) => !isBlank(row[flagKey]))
      : rows;
  }, [table, dataset.rows, filters, flaggedOnly, flagKey]);
  const isObject =
    table && objects.some((object) => object.dataset.id === dataset.id);
  return { tableRows, isObject };
};
